<template>
  <p style="display: none"></p>
</template>
<script>
import store from '@/store/store';
import router from '@/router/router';
export default {
  data() {
    return {};
  },
  computed: {
    activeExperienceID() {
      return store.getters['authStudent/activeExperienceID'];
    },
    activeExperience() {
      return store.getters['authStudent/activeExperience'];
    },
    settings() {
      return store.getters['authStudent/settings'];
    },
  },
  beforeCreate() {
    const appLoading = document.getElementById('loading-bg');
    appLoading.style.display = 'block';
  },

  beforeMount() {
    if (
      typeof this.settings['work_experience'] !== 'undefined' &&
      this.settings['work_experience'] == false
    ) {
      router.push('/student/dashboard');
    } else {
      /*if(typeof this.prework === 'undefined' || this.prework === null || !this.prework.status.completed) {
      router.push('/student/experiences/complete_prework');
    }*/
      if (!this.activeExperienceID) {
        router.push('/student/available-experiences');
      } else if (this.activeExperience) {
        if (this.activeExperience.type == 1)
          router.replace(
            '/student/work-experience/' + this.activeExperienceID + '/tour_and_induction',
          );
        else
          router.replace(
            '/student/work-experience/' + this.activeExperienceID + '/experience-info',
          );
      }
      const appLoading = document.getElementById('loading-bg');
      appLoading.style.display = 'none';
    }
  },
};
</script>
